/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import history from '../history';
import { showFormatedDate, BEHAVIOR_BLOSSOMS, EBS, DEMO, NE_ABA, BESTABA, CBG, AIP, BUILDABLOCKTHERAPY, SWANCONSULTINGINC, CAS, VICTORIOUSLEARNING, ABAORLANDO, POSITIVEBEHAVIORSTEPS, SOAR, HYPERIONCENTER, HELPINGHANDS, FUTURES, TFABA, IAT,showFormatedDateandTime, showFormattedTime, TEST } from '../actions/utilAction'
import PaginatorCustom from '../components/paginationCustom';
import { getOrganizationEncounter } from '../../src/modules/Dashboards/actions/StaffDashboardActions';
import { getExportCSVOrExcelAppointmentDocuments } from '../modules/Dashboards/actions/StaffDashboardActions';
import { renderDateField, renderTextField } from '../components/reduxFields';
import { Field, reduxForm, reset } from 'redux-form';
import { RaisedButton } from 'material-ui';
import moment from 'moment';

/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class EncounterTable extends Component {
  constructor(props) {
    
    super(props);
    this.state = {
      pageNumber:0,
      fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      toDate :  new Date(new Date().setDate(new Date().getDate())),
      searchText:'',
      isAdmin:false
    }
  }
  
  componentDidMount(){
    
    if(this.props.downloadData) {
      this.props.downloadData(this.downloadCSVORXLSDocument) 
    }

    this.loadEncounterData();
    if(this.props.roleName==="Admin"){
      this.setState({
        isAdmin:true
      })
    } 
  }
  downloadCSVORXLSDocument = ()=>{
    console.log("HI iam Encounter");
    
    let searchObj = {
      pageNumber: this.state.pageNumber>0 ? this.state.pageNumber : 1,
      pageSize: 10,
      sortColumn:'',
      sortOrder:'',
      fromDate:this.state.fromDate ? showFormatedDate(this.state.fromDate) : new Date(new Date().setDate(new Date().getDate() - 7))||'',
      toDate:this.state.toDate ? showFormatedDate(this.state.toDate) :new Date(new Date().setDate(new Date().getDate()))||'',
      searchText:this.state.searchText||'',
      extension:this.props.extension,
      isAdmin:this.state.isAdmin
    };
    this.props.getExportCSVOrExcelAppointmentDocuments(searchObj)
  }

  loadEncounterData(page_number) {
    this.setState({pageNumber:page_number})
    let searchObj = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sortColumn:'',
      sortOrder:'',
      fromDate:this.state.fromDate ? showFormatedDate(this.state.fromDate) : new Date(new Date().setDate(new Date().getDate() - 7))||'',
      toDate:this.state.toDate ? showFormatedDate(this.state.toDate) :new Date(new Date().setDate(new Date().getDate()))||'',
      searchText:this.state.searchText||'',
    };
    this.props.getOrganizationEncounter(searchObj);
  }

  handleViewEncounterClick=(event, obj) => {    
    //let clientId = base64Encode(`${obj.id}`);\
    if (obj.isBillableEncounter) {
      if(this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS)
      {
        if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else {
          history.push(`/session-encounter-behaviorblossoms/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT)
      {
        if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else {
          history.push(`/session-encounter-data-collection/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase().startsWith(EBS))
      {
        if(obj.notetypeId === 1){
          history.push(`/session-encounter-data-collection/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 2){
          history.push(`/session-encounter-early-intervention/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 3){
          history.push(`/session-encounter-delaware-ei-ebs/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 4){
          history.push(`/session-encounter-ifsp-developmenttime-ebs/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 5){
          history.push(`/session-encounter-illinois-evaluation-ebs/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 6){
          history.push(`/session-encounter-illinois-ebs/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === CBG)
      {
          if(obj.notetypeId === 1){
            history.push(`/session-encounter-cbg/${obj.patientAppointmentId}/${obj.id}`);
          }
          else if(obj.notetypeId === 2){
            history.push(`/progress-encounter-one/${obj.patientAppointmentId}/${obj.id}`);
          } else if(obj.notetypeId === 101){          
            history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
          }  else if(obj.notetypeId === 102){          
            history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
          }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === AIP)
      {
        if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else {
          history.push(`/session-encounter-aip/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === NE_ABA)
      {
        if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else {
          history.push(`/session-encounter-ne-aba/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS)
      {
        if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else {
          history.push(`/session-encounter-pbs/${obj.patientAppointmentId}/${obj.id}`);
        }
      }      
      else if(this.props.agencyName.toUpperCase() === BESTABA)
      {
        if(obj.notetypeId === 1){
          history.push(`/session-encounter-bt-bestaba/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 2){
          history.push(`/session-encounter-bcba-bestaba/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === SWANCONSULTINGINC)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 2){
          history.push(`/session-encounter-psychological-swan/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } 
      }
      else if(this.props.agencyName.toUpperCase() === CAS)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 2){
          history.push(`/progress-encounter-one/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } 
      }
      else if(this.props.agencyName.toUpperCase() === VICTORIOUSLEARNING)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
        else if(obj.notetypeId === 2){
          history.push(`/progress-encounter-one/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } 
      }
      else if(this.props.agencyName.toUpperCase() === ABAORLANDO)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 2){
          history.push(`/session-encounter-rbt-abaor/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 3){
          history.push(`/session-encounter-bcba-abaor/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } 
      }
      else if(this.props.agencyName.toUpperCase() === SOAR)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 2){          
          history.push(`/session-encounter-assessment-soar/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 3){          
          history.push(`/session-encounter-directtherapy-soar/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 4){          
          history.push(`/session-encounter-bcbasupervision-soar/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 5){          
          history.push(`/session-encounter-familytreatment-soar/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 6){          
          history.push(`/session-encounter-diagnosticevaluation-soar/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }  
      }
      else if(this.props.agencyName.toUpperCase() === HYPERIONCENTER)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 2){          
          history.push(`/session-encounter-hyperion/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === HELPINGHANDS || this.props.agencyName.toUpperCase() === TEST)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 2){          
          history.push(`/session-supervision-encounter-helpinghands/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === FUTURES)
      {
        if(obj.notetypeId === 1){
          //history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
          history.push(`/soap/${obj.patientAppointmentId}/${obj.id}/0/0`);
        } else if(obj.notetypeId === 2){          
          //history.push(`/session-psycheval-encounter-futures/${obj.patientAppointmentId}/${obj.id}`);
          history.push(`/session-psycheval-note-futures/${obj.patientAppointmentId}/${obj.id}/0/0`);
        } else if(obj.notetypeId === 3){          
          //history.push(`/session-slpeval-encounter-futures/${obj.patientAppointmentId}/${obj.id}`);
          history.push(`/session-slpeval-note-futures/${obj.patientAppointmentId}/${obj.id}/0/0`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else if(this.props.agencyName.toUpperCase() === TFABA)
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 2){          
          history.push(`/session-encounter-rbt-tfaba/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 3){          
          history.push(`/session-encounter-bcba-tfaba/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        }  else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }
      else
      {
        if(obj.notetypeId === 1){
          history.push(`/soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 101){          
          history.push(`/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`);
        } else if(obj.notetypeId === 102){          
          history.push(`/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`);
        }   else if(obj.notetypeId > 102){          
          history.push(`/client-customsession-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
      }      
    } else {
        if(this.props.agencyName.toUpperCase() === FUTURES)
        {
          history.push(`/non-billable-soap/${obj.patientAppointmentId}/${obj.id}/0/0`);
        }
        else
        {
          history.push(`/non-billable-soap-encounter/${obj.patientAppointmentId}/${obj.id}`);
        }
    }
  };


  handleReset = () => {
    this.props.dispatch(reset('EncounterTableForm'));
    this.setState({
      searchText:'',
      fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      toDate :  new Date(new Date().setDate(new Date().getDate())),
    },()=>this.loadEncounterData())
  
  };


  showTableData() {
    return this.props.OrganizationEncounter.data.map((data) => {
      return (
        <TableRow key={data.patientAppointmentId} style={{ background: `${data.billableEncounterColorCode}`}}>
          <TableRowColumn width="10%">{data.staffName}</TableRowColumn>
          <TableRowColumn width="15%">{data.clientName}</TableRowColumn>
          <TableRowColumn width="10%">{data.locationName}</TableRowColumn>
          <TableRowColumn width="7%">{data.day}</TableRowColumn>          
          <TableRowColumn width="25%">{showFormatedDate(data.dateOfService)}{' (' + showFormattedTime(data.startDateTime) + ' - ' + showFormattedTime(data.endDateTime) + ')'}</TableRowColumn>
          <TableRowColumn width="10%">{data.serviceType}</TableRowColumn>
          <TableRowColumn width="10%">{data.status}</TableRowColumn>
          <TableRowColumn width="5%"><button onClick={(e) => this.handleViewEncounterClick(e, data)} type="button" title="View Session Note" className="tbactionbtn blackfont"><i className="fa fa-eye" aria-hidden="true"></i></button></TableRowColumn>          
        </TableRow>
      );
    });
  }
  
  onDateChange=(input, value)=> {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value },()=>this.loadEncounterData());
  }

  handleSearchChange = (event)=> {
    
    if (event.target.value.length > 0) {
      this.setState({
       searchText:event.target.value
      },()=>this.loadEncounterData())  
    } else if (event.target.value.length === 0) {
      this.loadEncounterData();
    }
  }


  render() {
    let {handleSubmit}=this.props
    return (
      <div>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" >
              <div className="row end-flex">
              <div className="col-sm-3 ml-10">
                  <Field
                      name="Encounter Table"
                      floatingLabelText="Search"
                      maxLength='25'
                      onChange={this.handleSearchChange}
                      component={renderTextField}
                  />
                </div>
                <div className="col-sm-3 ml-10">
                  <Field name="fromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.fromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-3 ml-10">
                  <Field name="toDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.fromDate}
                    selected={this.state.toDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="reset-btn col-sm-3 btn_rt">
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>

        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn width="10%">Practitioner</TableHeaderColumn>
              <TableHeaderColumn width="15%">Client Name</TableHeaderColumn>
              <TableHeaderColumn width="10%">Location</TableHeaderColumn>
              <TableHeaderColumn width="7%">Day</TableHeaderColumn>              
              <TableHeaderColumn width="25%">DOS</TableHeaderColumn>     
              <TableHeaderColumn width="10%">Service Type</TableHeaderColumn>         
              <TableHeaderColumn width="10%">Status</TableHeaderColumn>
              <TableHeaderColumn width="5%">View</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.OrganizationEncounter && this.props.OrganizationEncounter.data && this.props.OrganizationEncounter.data.length > 0 ?
              this.showTableData()
              : 
              <TableRow>
                <TableRowColumn colSpan="6">No Record Found</TableRowColumn>
              </TableRow>
              }
          </TableBody>
        </Table>
        {this.props.OrganizationEncounter.data && this.props.OrganizationEncounter.data.length ?
          <PaginatorCustom data={this.props.OrganizationEncounter.meta} handlePageChange={(page_number) => this.loadEncounterData(page_number)} />
          : null}
      </div>
    );
  }
}


EncounterTable = reduxForm({
  form: 'EncounterTableForm',
})(EncounterTable);

function mapStateToProps(state) {
  let  rolename = ""
  if (state.login.userPermission) {
       rolename = state.login.loginUserInfo&&state.login.loginUserInfo.users1&&state.login.loginUserInfo.users1.userRoles.roleName
    }

    
  return {
    roleName:rolename,
    OrganizationEncounter: state.staff_dashboard ? state.staff_dashboard.OrganizationEncounter : {},
    BottonPanel_loading: state.staff_dashboard.BottonPanel_loading,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  }
}

export default connect(mapStateToProps, { getOrganizationEncounter,getExportCSVOrExcelAppointmentDocuments })(EncounterTable);



// WEBPACK FOOTER //
// ./src/adminCharts/EncounterTable.js